import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import { fetchCreateAnswer, TCreateAnswerResponse } from '../../repositories/newbuilding-reviews/v1/create-answer';
import { INewAnswer } from '../../types/newAnswer';
import { prepareNewAnswer } from '../../mappers/prepareNewAnswer';

export interface IFetchAnswerParams {
  httpApi: IHttpApi;
  parameters: {
    reviewId: string;
    newAnswer: INewAnswer;
  };
}

export async function addAnswer({ httpApi, parameters: { reviewId, newAnswer } }: IFetchAnswerParams): Promise<void> {
  const result: TCreateAnswerResponse = await fetchCreateAnswer({
    httpApi,
    parameters: prepareNewAnswer(reviewId, newAnswer),
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'reviews#fetchAddAnswer',
      message: '',
    });
  }
}
